import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UserEventHistoryItem, UserEventHistoryService } from '../../services/user-event-history.service';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-event-history',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './event-history.component.html',
  styleUrl: './event-history.component.scss'
})
export class EventHistoryComponent implements OnInit {
  events: UserEventHistoryItem[] = [];

  constructor(private readonly userEventHistoryService: UserEventHistoryService) {}

  ngOnInit(): void {
    this.loadEvents();
    this.syncWithBackend();
  }

  clearAll(): void {
    this.userEventHistoryService.clearHistory();
    this.loadEvents();
  }

  private loadEvents(): void {
    this.events = this.userEventHistoryService.getRecentEvents();
  }

  private syncWithBackend(): void {
    this.userEventHistoryService.syncFromServer().subscribe((events) => {
      this.events = events;
    });
  }
}
